const Terms = () => {
  return (
    <div className="legal-wrap" data-testid="terms-page">
      <a className="legal-back" href="/" data-testid="terms-back-link">
        ← Back to FortellAI
      </a>
      <h1>FortellAI – Terms of Service</h1>
      <p className="legal-updated">Last updated July 2026</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By downloading or using FortellAI, you agree to these Terms of Service. If you do not
        agree, please discontinue use of the app.
      </p>

      <h2>2. Entertainment Purposes Only</h2>
      <p>
        All readings, scans, and fortunes generated by FortellAI are for entertainment purposes
        only. They must not be relied upon as professional, medical, legal, financial, or
        psychological advice. No outcomes are guaranteed or predicted.
      </p>

      <h2>3. Free &amp; Premium Access</h2>
      <p>FortellAI is free to download.</p>
      <p>
        The app offers optional paid features, including individual one‑time scan purchases and
        subscription upgrades.
      </p>

      <h3 className="legal-subhead">Paid Scans</h3>
      <ul className="legal-list">
        <li>Individual scans are sold as one‑time purchases.</li>
        <li>Each purchase unlocks one scan only.</li>
        <li>Additional scans require additional one‑time purchases.</li>
      </ul>

      <h3 className="legal-subhead">FortellAI Premium</h3>
      <p>FortellAI Premium ($7.99 CAD/month or $39.99 CAD/year) provides:</p>
      <ul className="legal-list">
        <li>Unlimited scans</li>
        <li>No ads</li>
        <li>Deep readings</li>
        <li>Bonus daily fortune</li>
      </ul>
      <p>Prices may vary by region.</p>

      <h2>4. Billing &amp; Cancellation</h2>
      <ul className="legal-list">
        <li>Payments are processed through your Apple App Store or Google Play account.</li>
        <li>
          Subscriptions renew automatically unless cancelled at least 24 hours before the renewal
          date.
        </li>
        <li>
          You can manage or cancel your subscription at any time through your device's store
          subscription settings.
        </li>
        <li>
          Cancelling a subscription stops future charges but does not refund the current billing
          period.
        </li>
      </ul>

      <h2>5. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul className="legal-list">
        <li>Upload unlawful, harmful, or infringing images</li>
        <li>Attempt to reverse‑engineer, disrupt, or interfere with the service</li>
        <li>Use FortellAI to harass, threaten, or harm others</li>
      </ul>

      <h2>6. Intellectual Property</h2>
      <p>
        The FortellAI name, logo, design, and content formats are the property of FortellAI.
      </p>
      <p>You may share your personal readings freely for non‑commercial use.</p>

      <h2>7. Disclaimer &amp; Limitation of Liability</h2>
      <p>FortellAI is provided "as is" without warranties of any kind.</p>
      <p>
        To the fullest extent permitted by law, FortellAI is not liable for any decisions, actions,
        or outcomes resulting from use of the app or reliance on its content.
      </p>

      <h2>8. Changes &amp; Contact</h2>
      <p>
        We may update these Terms from time to time. Continued use of the app after changes
        indicates acceptance of the updated Terms.
      </p>
      <p>The latest version is always available at www.fortellai.ca.</p>
    </div>
  );
};

export default Terms;
